const trackWsBlockContent = (blockNode) => {
  // Update data-ws-slots and data-ws-observed-slots attributes of ws-block on first element child
  if (blockNode.isContentChanged) blockNode.isContentChanged();
};

export default trackWsBlockContent;
